import safeGetPathname from './safeGetPathname';
export default (sourceUrl, newProductBaseUrl) => {
  const sourcePathname = safeGetPathname(sourceUrl);
  const newProductBasePathname = safeGetPathname(newProductBaseUrl);
  const sourceSplits = sourcePathname.split('/');
  const targetSplits = newProductBasePathname.split('/');
  sourceSplits[1] = targetSplits[1];
  const newUrl = new URL(sourceUrl);
  newUrl.pathname = sourceSplits.join('/');
  return newUrl.href;
};
//# sourceMappingURL=replaceProductInUrl.js.map